<template>
  <div>
    <recorder ref="recorder" v-if="showRecorder" style="height: 55px;padding-right: 10px" @submitAction="loadData" :recordingTip="recordingTip" :patientName="patientName" :formId="formId" :formName="formName" :projectId="projectId" :patientId="patientId"></recorder>
    <a-collapse v-model="activeKey" :accordion="true">
      <a-collapse-panel  v-for="(item,index) in fileList" :key="`${index}`"  :header="item.name">
        <play @removeAction="loadData" :data="item"></play>
      </a-collapse-panel>
    </a-collapse>
    <image-file :show="showRecorder"  :formId="formId" :projectId="projectId" :patientId="patientId"></image-file>
  </div>
</template>

<script>
  import Recorder from './Recorder'
  import Play from './Play'
  import { getAction } from '@/api/manage'
  import ImageFile from './ImageFile'

  export default {
    name: 'Index',
    components: { ImageFile, Recorder,Play },
    props:{

      showRecorder:{
        default:true,
      },
      patientName:{
        default:''
      },
      formName:{
        default:''
      },
      formId:{
        default:''
      },
      projectId:{
        default:''
      },
      patientId:{
        default:''
      },
      recordingTip:{
        default:false
      }
    },
    data () {
      return {
        fileList:[],
        activeKey:''
      }
    },
    mounted(){
      this.loadData()
    },
    methods: {
      loadData(){
        getAction('/project/projectFile/listAll',{serveId:this.formId,projectId: this.projectId,type:'3'}).then(res=>{
          if(res.success){
            this.fileList = res.result
          }
        })
      },
      /**
       * 保存的时候主动结束录音
       */
      submitFormHandle(formItem,callBack){
        if(this.$refs.recorder){
          this.$refs.recorder.submitFormHandle(formItem,callBack)
        }else{
          callBack()
        }
      },
      saveAllRecorder2(){
        if(this.$refs.recorder){
          this.$refs.recorder.saveAllRecorder2()
        }
      },
      /**
       * 结束录音
       */
      closeFormHandle(){
        this.$refs.recorder.closeFormHandle()
      }
    },

  }
</script>

<style lang='less' scoped>
</style>